window.addEventListener('DOMContentLoaded', () => {
  // deals section counter
  let coutnerEle = document.querySelector('.counter-wrapper');
  if (coutnerEle) {
    let futureDate = coutnerEle.dataset.date,
        counterHours = document.querySelector('[data-hours]'),
        counterMinutes = document.querySelector('[data-minutes]'),
        counterSeconds = document.querySelector('[data-seconds]'),
        counterDays = document.querySelector('[data-days]');

    window.setInterval(countDown, 1000);

    function countDown() {
      var now = new Date();
      // var future = new Date(futureDate);
      var [datePart, timePart] = futureDate.split(" ");
      var [day, month, year] = datePart.split("/");
      var [hours, minutes, seconds] = timePart.split(":");
      var future = new Date(year, month - 1, day, hours, minutes, seconds);

      var timeLeft = future - now;
      var milli = timeLeft;

      var seconds = milli / 1000;
      var minutes = seconds / 60;
      var hours = minutes / 60;
      var days = hours / 24;
      var spareSeconds = seconds % 60;
      var spareMinutes = minutes % 60;
      var spareHours = hours % 24;
      var spareDays = days % 365;
      minutes = parseInt(minutes);
      hours = parseInt(hours);
      days = parseInt(days);
      spareSeconds = parseInt(spareSeconds);
      spareMinutes = parseInt(spareMinutes);
      spareHours = parseInt(spareHours);
      spareDays = parseInt(spareDays);
      var spareDaysInt = spareDays;

      days = padNumber(days);
      hours = padNumber(hours);
      minutes = padNumber(minutes);
      spareSeconds = padNumber(spareSeconds);
      spareMinutes = padNumber(spareMinutes);
      spareHours = padNumber(spareHours);
      spareDays = padNumber(spareDays);


      // bread counter in 2 digits
      spareDays = Array.from(String(spareDays), Number);
      spareHours = Array.from(String(spareHours), Number);
      spareMinutes = Array.from(String(spareMinutes), Number);
      spareSeconds = Array.from(String(spareSeconds), Number);

      // hide date filed is 00
      if(spareDaysInt == '00') {
        counterDays.style.display = 'none';
      } else {
        counterDays.style.display = null;
        counterDays.querySelectorAll('span')[0].innerHTML = spareDays[0];
        counterDays.querySelectorAll('span')[1].innerHTML = spareDays[1];
      }
      counterHours.querySelectorAll('span')[0].innerHTML = spareHours[0];
      counterHours.querySelectorAll('span')[1].innerHTML = spareHours[1];
      counterMinutes.querySelectorAll('span')[0].innerHTML = spareMinutes[0];
      counterMinutes.querySelectorAll('span')[1].innerHTML = spareMinutes[1];
      counterSeconds.querySelectorAll('span')[0].innerHTML = spareSeconds[0];
      counterSeconds.querySelectorAll('span')[1].innerHTML = spareSeconds[1];

      if (milli <= 0) {
        counterDays.style.display = 'none';
        counterHours.querySelectorAll('span')[0].innerHTML = '00'
        counterHours.querySelectorAll('span')[1].innerHTML = '00'
        counterMinutes.querySelectorAll('span')[0].innerHTML = '00'
        counterMinutes.querySelectorAll('span')[1].innerHTML = '00'
        counterSeconds.querySelectorAll('span')[0].innerHTML = '00'
        counterSeconds.querySelectorAll('span')[1].innerHTML = '00'
      }
    }

    function padNumber(number) {
      if (number < 10) {
        number = "0" + number;
      }
      return number;
    }
  }

})
